import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "move-out",
  "use": "move-out-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"move-out\"><path d=\"M11 10.414V17h2v-6.586l2.293 2.293 1.414-1.414L12 6.586l-4.707 4.707 1.414 1.414L11 10.414zM21 19v-1h-2v1h-1v2h1c1.103 0 2-.896 2-2zM13 21h3v-2h-3v2zM8 21h3v-2H8v2zM5 21h1v-2H5v-1H3v1a2 2 0 002 2zM19 6h2V5c0-1.102-.897-2-2-2h-1v2h1v1zM13 5h3V3h-3v2zM8 5h3V3H8v2zM5 5h1V3H5c-1.104 0-2 .898-2 2v1h2V5zM19 11h2V8h-2v3zM19 16h2v-3h-2v3zM3 11h2V8H3v3zM3 16h2v-3H3v3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol